// extracted by mini-css-extract-plugin
export default {"footer":"EnterFooter_footer__DavpE","button":"EnterFooter_button__maiPq","link":"EnterFooter_link__crq6W","block":"EnterFooter_block__zl0LD"};